<template>
  <div>
    <div>
      <b-modal id="modal-lastResult" :title="this.rowUsedForDetails.name" okOnly>
        <p class="my-4">
          <b>{{ $t('dashboard.widgets.LatestResult.codigo_exame') }}:</b> {{ this.rowUsedForDetails.exam_code }}
          <b>=</b> {{ this.rowUsedForDetails.value_quantity_value }}
        </p>
      </b-modal>
    </div>

    <data-table
        :columns="datatable.columns"
        :datas="logslist"
        :styleClass="datatable.styleClass"
        :eventsHandler="datatable.eventsHandler"
        :tableMode="datatable.tableMode"
        :totalRecords="datatable.totalRecords"
        :service="datatable.service"
        :selectOptions="{
         enabled: false,
        }"
        @update-data="updateData"
        @update-total="updateTotalRecords"
        ref="LogsDataTable"
    />

  </div>
</template>

<script>
import DataTable from '@/components/data-table'
import ModalComponent from '@/components/Modal'
import $axios from '@/providers/AxiosServiceProvider'
import HttpStatus from 'http-status-codes'

export default {
  name: 'LatestResult',
  components: {
    DataTable,
    ModalComponent
  },
  data() {
    return {
      time: '',
      pages: {},
      logslist: [],
      datatable: {
        styleClass: 'table table-bordered dataTable',
        service: 'vam/latest-result',
        columns: [
          {
            label: this.$t('dashboard.widgets.LatestResult.columns.vns_equipamento'),
            field: 'vns',
            filterOptions: {
              enabled: false,
              placeholder: 'Vns'
            }
          },
          {
            customType: 'Recipiente',
            label: this.$t('dashboard.widgets.LatestResult.columns.recipiente'),
            class: 'badge badge-primary',
            callback: this.callback,
            icon: 'fas fa-search text-default',
            field: 'identifier',
            filterOptions: {
              enabled: false,
              placeholder: this.$t('dashboard.widgets.LatestResult.columns.recipiente')
            }
          },
          {
            label: this.$t('dashboard.widgets.LatestResult.columns.exame'),
            field: 'exam_code',
            filterOptions: {
              enabled: false,
              placeholder: this.$t('dashboard.widgets.LatestResult.columns.exame')
            }
          },
          {
            label: this.$t('dashboard.widgets.LatestResult.columns.paciente'),
            field: 'name',
            filterOptions: {
              enabled: false,
              placeholder: this.$t('dashboard.widgets.LatestResult.columns.paciente')
            }
          },
          {
            label: this.$t('dashboard.widgets.LatestResult.columns.data_hora'),
            field: 'created_at',
            type: 'date',
            dateInputFormat: 'yyyy-MM-dd\'T\'HH:mm:ss.SSSSSSXXX',
            dateOutputFormat: 'dd/MM/y HH:mm:ss'
          },
          {
            customTypeStatus: 'status',
            label: this.$t('dashboard.widgets.LatestResult.columns.status'),
            callback: this.callbackExam,
            class: 'badge badge-danger',
            classSucess: 'badge badge-success',
            classWarning: 'badge badge-warning',
            sucessLabel: this.$t('dashboard.widgets.LatestResult.columns.liberado'),
            warningLabel: this.$t('dashboard.widgets.LatestResult.columns.alerta'),
            dangerLabel: this.$t('dashboard.widgets.LatestResult.columns.bloqueado'),
            field: 'status'
          }
        ],
        tableMode: 'remote',
        eventsHandler: {
          onSelectRow: this.onSelectRow
        },
        totalRecords: 0
      },
      container_class: 'pagination',
      li_class: 'paginate_button',
      actives: 0,
      rowUsedForDetails: {},
      selectedRows: [],
      config: {
        timeout: 50000, // timeout 50 seconds
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      },
      showModal: false
    }
  },
  mounted() {
    this.$refs.LogsDataTable.loadItems()
    this.timer = setInterval(() => {
      this.$refs.LogsDataTable.loadItems()
    }, 50000)
  },

  methods: {
    callbackExam(row) {
      if (row.status === 'Blocked') {
        this.$snotify.clear()
        this.$snotify.confirm(
            this.$t('dashboard.widgets.LatestResult.aviso_processamento'),
            this.$t('dashboard.widgets.LatestResult.tem_certeza'),
            {
              showProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              buttons: [
                {
                  text: 'Sim',
                  action: toast => {
                    this.$snotify.remove(toast.id)
                    this.$Progress.start()
                    $axios.post('vam/trigger/unlock', {
                      exam_id: row.id
                    }).then(response => {
                      if (response.data.data === 'success') {
                        this.$snotify.success(
                            this.$t('dashboard.widgets.LatestResult.exame_liberado'),
                            this.$t('dashboard.widgets.LatestResult.sucesso')
                        )
                        this.$refs.LogsDataTable.loadItems()
                        this.$Progress.finish()
                      }
                    })
                  },
                  bold: true
                },
                {
                  text: 'Não',
                  action: toast => {
                    this.$snotify.remove(toast.id)
                  },
                  bold: true
                }
              ]
            }
        )
      }
    },
    cancelAutoUpdate() {
      clearInterval(this.timer)
    },
    callback(row) {
      this.rowUsedForDetails = {}
      this.rowUsedForDetails = row
      this.$bvModal.show('modal-lastResult')
    },
    openListPage(page) {
      this.showLogs()
      this.editPage = false
      this.listPage = true
    },
    async showLogs() {
      try {
        let result = await $axios.get('vam/latest-result')
        if (result.status === HttpStatus.OK) {
          this.datatable.totalRecords = result.data.total
          this.logslist = result.data.data
        }
      } catch (e) {
        console.log(e)
      }
    },
    clickPage(pageNum) {
      this.showLogs(pageNum)
    },
    onSelectRow(rows) {
      this.selectedRows = rows.selectedRows.filter(
          row => row.name !== undefined
      )
    },
    updateData(newData) {
      this.logslist = newData.data
    },
    updateTotalRecords(newTotal) {
      this.datatable.totalRecords = newTotal
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>

<style>
</style>
